<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '.';

const props = defineProps({
    variant: { type: null, required: false },
    size: { type: null, required: false },
    class: { type: null, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false, default: 'button' },
    type: {
        type: null,
        required: false,
        default: 'button',
        validator(value, props) {
            return ['button', 'submit', 'reset'].includes(value);
        },
    },
});
</script>

<template>
    <Primitive :as="as" :as-child="asChild" :class="cn(buttonVariants({ variant, size }), props.class)" :type="type" data-slot="button">
        <slot />
    </Primitive>
</template>
